import { useAppSelector } from "store/hooks"
import SubscriptionPrivilege from "types/enums/SubscriptionPrivilege"

import hasSubscriptionAccess from "utils/hasSubscriptionAccess"
import { ChartUnavailableOverlay } from "components/common/ChartUnavailableOverlay"

import { DashboardWidgetSection } from "../components/Dashboard/Dashboard"
import { WidgetScheduled } from "./WidgetScheduled"
import { WidgetTestStatuses } from "./WidgetTestStatuses"

export const PerformanceTestsSection = () => {
  const userProfile = useAppSelector(state => state.user.userProfile)
  const unsupported = !(userProfile ? hasSubscriptionAccess(userProfile, SubscriptionPrivilege.PerformanceTest) : false)

  return (
    <DashboardWidgetSection title="Performance Tests">
      <ChartUnavailableOverlay isUnsupported={unsupported} privilege={SubscriptionPrivilege.PerformanceTest}>
        <WidgetScheduled unsupported={unsupported} />
      </ChartUnavailableOverlay>
      <ChartUnavailableOverlay isUnsupported={unsupported} privilege={SubscriptionPrivilege.PerformanceTest}>
        <WidgetTestStatuses unsupported={unsupported} />
      </ChartUnavailableOverlay>
    </DashboardWidgetSection>
  )
}
